import Loadable from 'react-loadable';
import Loader from '../../components/UIComponents/Loader';

export const LoadableDashboard = Loadable({
  loader: () => import('./Dashboard'),
  loading: Loader
});
